export const liveStreamEventRoutes = {
  overview: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}`,
  customize: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}/customize/brand`,
  customizeRegistration: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/customize/registration`,
  customizeRegistrationForm: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/customize/form`,
  customizeEventRoom: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/customize/event_room`,
  customizeEmails: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/customize/emails`,
  eventDetails: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}/event-details`,
  invitePanelist: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}/invite`,
  shareLinks: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}/share`,
  simulcast: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}/simulcast`,
  hostView: (hashedId: string): string => `/live/onair/${hashedId}/`,
  panelistView: (hashedId: string, joinKey: string): string => `/live/join/${hashedId}/${joinKey}`,
  joinPage: (hashedId: string, joinKey: string): string => `/live/${hashedId}/join/${joinKey}`,
  hostJoinPage: (hashedId: string): string => `/live/${hashedId}/join`,
  registration: (hashedId: string): string => `/live/${hashedId}/registration`,
  addActiveParticipant: (hashedId: string): string => `/live/${hashedId}/active_participants/add`,
  removeActiveParticipant: (hashedId: string): string =>
    `/live/${hashedId}/active_participants/remove`,
  recorder: (hashedId: string): string =>
    `${window.location.origin}/live/events/${hashedId}/record`,
  analytics: (mediaHashedId: string): string => `/stats/medias/${mediaHashedId}`,
  audienceView: (liveStreamHashedId: string): string => `/live/events/${liveStreamHashedId}`,
  aiDescription: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/generate-description`,
  eventRecapAnalytics: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/event-analytics`,
  liveRegistrationAnalytics: (liveStreamHashedId: string): string =>
    `/live/${liveStreamHashedId}/event-analytics/registrations`,
  multiplex: (liveStreamHashedId: string): string => `/live/${liveStreamHashedId}/multiplex`,
};
